import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';

import PageProjectsDashboard from 'hcp/components/page/projects/dashboard';

<template>
  {{pageTitle (t "projects-dashboard.dashboard")}}

  <PageProjectsDashboard
    @organization={{@controller.model.organization}}
    @project={{@controller.model.project}}
    @resources={{@controller.model.resources}}
    @billing={{@controller.model.billing}}
    @secretsApps={{@controller.model.secretsApps}}
  />
</template>
